// eslint-disable-next-line @nx/enforce-module-boundaries
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import { useScanDataMetricsTimeSeriesQuery } from '@occc/graphql';

export const useScanDataMetricsTimeSeries = (submissionDateEquals: string) => {
  return useScanDataMetricsTimeSeriesQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter: {
        submissionDateEquals,
      },
    },
  });
};
